import React, { useEffect, useState } from "react"
import alanBtn from "@alan-ai/alan-sdk-web";
import wordsToNumbers from "words-to-numbers";
import NewsCards from "./components/NewsCards/NewsCards";
import useStyles from "./styles.js";

const alanKey = "59ecd5ec06a9d2779e336a46205cac892e956eca572e1d8b807a3e2338fdd0dc/stage";

const App = () => {
    const [newsArticles,setNewsArticles] = useState([]);
    const [activeArticle,setActiveArticle] = useState(-1);
    const classes = useStyles();
    useEffect(() => {
        alanBtn({
           key:alanKey,
           onCommand: ({command, articles,number}) => {
               if(command === "newHeadlines"){
                  //alert("This code was executed");
                  setNewsArticles(articles);
                  setActiveArticle(-1);
               }
               else if(command === "highlight"){
                   setActiveArticle((prevActiveArticle) => prevActiveArticle+1);
               }
               else if(command === "open"){
                  // console.log(number);
                  const parsedNumber = number.length > 2 ? wordsToNumbers(number, {fuzzy:true}) : number;
                  const article = articles[parsedNumber - 1];
                  
                  if(parsedNumber > 20){
                      alanBtn().playText('Please try that again');
                  }
                  else if(article){
                    window.open(article.url,'_blank');
                    alanBtn().playText('opening...');
                  }
                   
               }
           }
        });
    },[])
    return (
        <div>
            <div className={classes.logoContainer}>
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTClQvlSz73J81SmvOFFXrbjhKx8yQ3AjMCVk9LQ9KEoGCSM33tYcnNxZxU70v7uYbsidI&usqp=CAU" className={classes.alanLogo} alt="alan logo"  />
            </div>
            <NewsCards articles={newsArticles} activeArticle={activeArticle}/>
        </div>
    );
}
export default App;